$(function() {

  // support topic content modal

  var $topicModal = $('#support-topic-detail');

  $topicModal.on('show.bs.modal', function(e) {
    var topic = $(e.relatedTarget),
        topicTitle = topic.html(),
        topicContent = topic.next('.support-topics__content').html();

    $topicModal.find('.support-topic-detail__title').html(topicTitle);
    $topicModal.find('.support-topic-detail__content').html(topicContent);

  });

});